import runtimeEnv from "./runtimeEnv";

window.env = runtimeEnv;
